var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"editor"}),_c('div',{staticClass:"html"},[_c('div',{staticClass:"html-content",domProps:{"innerHTML":_vm._s(_vm.html)}}),_c('button',{staticClass:"download",on:{"click":_vm.download}},[_vm._v("下载html")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }